export const ZeroResultTypes = {
    Marketplace: "MARKETPLACE",
    RecentlyViewed: "RECENTLY_VIEWED",
    OrSearch: "OR_SEARCH"
};

export type ZeroResultType = (typeof ZeroResultTypes)[keyof typeof ZeroResultTypes];
